import { call, put, takeEvery } from 'redux-saga/effects'
import {
	fileUploadRequest,
	fileUploadSuccess,
	fileUploadFailure
} from '../actions'

import { waitForState, apiFormDataRequest } from 'utils'

function* requestUploadFile({ payload: { id, appId, pendingFile } }) {
	try {
		const token = yield call(waitForState, state => state.user.token)
		const body = yield new FormData()
		yield body.append('icon', pendingFile, 'icon')

		const response = yield call(() => {
			return apiFormDataRequest(
				token,
				'/application/' + appId + '/icon',
				'post',
				body
			)
		})

		if (response.status === 202) {
			const json = yield call(() => response.json())
			const newIconPayload = {
				id,
				appId,
				url: json.icons[2],
				receivedAt: Date.now()
			}
			yield put(fileUploadSuccess(newIconPayload))
		} else {
			throw new Error("Icon couldn't be uploaded")
		}
	} catch (error) {
		yield put(fileUploadFailure({ error }))
	}
}

export function* watchUploadsRequests() {
	yield takeEvery(fileUploadRequest, requestUploadFile)
}



// WEBPACK FOOTER //
// ./src/sagas/uploads.js